import { AfterContentInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'rn-channel-list-item',
    templateUrl: './channel-list-item.component.html',
    styleUrls: ['./channel-list-item.component.scss'],
    standalone: true,
    imports: [DatePipe]
})
export class ChannelListItemComponent {
  @Input() fname: string;
  @Input() lname: string;
  @Input() tagName: string;
  @Input() created: string;
  @Input() updated: string; // optional
  @Input() isHighlighted: string;
  
  constructor() { }
}
